// useClube.js — "esta pessoa assina o Clube Insigne?"
//
// A resposta muda o que a página do livro oferece: para o assinante, o caminho
// principal deixa de ser "comprar" e passa a ser "ler agora". Sem isto, quem
// paga R$ 50,00 por mês precisaria ir até o perfil para descobrir que já podia
// ler o livro que está olhando — e o clube pareceria não funcionar.
//
// A CHECAGEM AQUI É SÓ PARA A TELA. Quem decide se a leitura acontece é o
// servidor, a cada página. Uma verificação no navegador nunca é permissão; é
// só o que evita mostrar o botão errado.
import { useEffect, useState } from "react";
import { useAuth } from "../services/context/AuthContext";

const API_URL = process.env.REACT_APP_API;

export default function useClube() {
  const { user, loading: authLoading } = useAuth();
  const [status, setStatus] = useState(null);
  const [carregando, setCarregando] = useState(true);

  // `carregando` SÓ VIRA false QUANDO A RESPOSTA É DEFINITIVA.
  //
  // Antes ele caía para false já na primeira renderização — o login ainda não
  // tinha sido restaurado, `user` era null, e o hook concluía "não assina". E
  // quando o `user` chegava, a busca começava com `carregando` ainda false. Por
  // um instante, todo assinante parecia não assinar: no catálogo a barra do
  // Clube piscava, e a vitrine do livro do Clube (/clube/livros/:id), que manda
  // quem não assina para a loja, mandava o próprio assinante embora ao
  // recarregar a página.
  useEffect(() => {
    let vivo = true;

    if (authLoading) return;

    if (!user) {
      setStatus(null);
      setCarregando(false);
      return;
    }

    setCarregando(true);
    (async () => {
      try {
        const r = await fetch(`${API_URL}clube/status`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        if (vivo && r.ok) setStatus(await r.json());
      } catch (_) {
        /* falha aqui só significa "não sabemos": a tela cai no fluxo de compra */
      } finally {
        if (vivo) setCarregando(false);
      }
    })();

    return () => { vivo = false; };
  }, [user, authLoading]);

  return {
    assinante: !!status?.ativa,
    diasRestantes: Number(status?.dias_restantes) || 0,
    status,
    carregando,
  };
}
